import { Box, Button, Typography } from "@mui/material"
import { ErrorOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

import { getPaymentMethodLabel } from "../../../utils/paymentMethodLabels"

import type { CompanyPaymentTypeMethod } from "@/graphql/codegen/graphql"
import colors from "@/styles/colors"

interface Props {
  approvePaymentType: (paymentMethodId: string) => Promise<void>
  paymentTypeMethod: CompanyPaymentTypeMethod
}

export const ApprovePaymentType: FC<Props> = ({ approvePaymentType, paymentTypeMethod }) => {
  return (
    <Box className='flex w-full items-center justify-between rounded-[4px] bg-tertiary-yellow-100 px-[16px] py-[6px]'>
      <Box className='flex items-center gap-2'>
        <ErrorOutlined sx={{ color: colors.tertiary.yellow["700"] }} />{" "}
        <Typography className='text-tertiary-yellow-900'>
          {getPaymentMethodLabel(paymentTypeMethod.method)} payment methods needs approval to become ACTIVE
        </Typography>
      </Box>

      <Button
        variant='outlined'
        color='warning'
        size='small'
        onClick={() => approvePaymentType(paymentTypeMethod.companyPaymentMethodId)}
      >
        Approve
      </Button>
    </Box>
  )
}
